import type { ComponentPropsWithoutRef, ReactNode } from "react";
import * as RadixSelect from "@radix-ui/react-select";
import { Check, ChevronDown } from "lucide-react";
import s from "./Select.module.css";

export const Select = RadixSelect.Root;
export const SelectValue = RadixSelect.Value;
export const SelectGroup = RadixSelect.Group;
export const SelectLabel = RadixSelect.Label;

export interface SelectTriggerProps extends ComponentPropsWithoutRef<typeof RadixSelect.Trigger> {
  placeholder?: string;
}

export function SelectTrigger({ className, placeholder, ...rest }: SelectTriggerProps) {
  const classes = className ? `${s.trigger} ${className}` : s.trigger;
  return (
    <RadixSelect.Trigger className={classes} {...rest}>
      <RadixSelect.Value placeholder={placeholder} />
      <RadixSelect.Icon className={s.icon}>
        <ChevronDown aria-hidden size={16} />
      </RadixSelect.Icon>
    </RadixSelect.Trigger>
  );
}

export interface SelectContentProps extends ComponentPropsWithoutRef<typeof RadixSelect.Content> {
  children: ReactNode;
}

export function SelectContent({ className, children, ...rest }: SelectContentProps) {
  const classes = className ? `${s.content} ${className}` : s.content;
  return (
    <RadixSelect.Portal>
      <RadixSelect.Content
        className={classes}
        position="popper"
        sideOffset={4}
        collisionPadding={16}
        {...rest}
      >
        <RadixSelect.Viewport className={s.viewport}>{children}</RadixSelect.Viewport>
      </RadixSelect.Content>
    </RadixSelect.Portal>
  );
}

export interface SelectItemProps extends ComponentPropsWithoutRef<typeof RadixSelect.Item> {
  children: ReactNode;
}

export function SelectItem({ className, children, ...rest }: SelectItemProps) {
  const classes = className ? `${s.item} ${className}` : s.item;
  return (
    <RadixSelect.Item className={classes} {...rest}>
      <RadixSelect.ItemText>{children}</RadixSelect.ItemText>
      <RadixSelect.ItemIndicator className={s.indicator}>
        <Check aria-hidden size={16} />
      </RadixSelect.ItemIndicator>
    </RadixSelect.Item>
  );
}
